import { BaseModel } from 'storm-react-diagrams';
import { DesignMap } from '../../../../types';
import { BaseChangeItemConflict } from '../types';
import { getChangeItemModel } from './get-change-item-model';

export interface GetConflictItemModelProps {
  conflictItem: BaseChangeItemConflict;
  sourceDesignMap: DesignMap;
  targetDesignMap: DesignMap;
}

export function getConflictItemModel({
  conflictItem,
  sourceDesignMap,
  targetDesignMap
}: GetConflictItemModelProps): BaseModel<any> | null {
  const { key, source, target } = conflictItem;

  return getChangeItemModel({
    key,
    changeItem: source,
    designMap: sourceDesignMap
  }) ?? getChangeItemModel({
    key,
    changeItem: target,
    designMap: targetDesignMap
  });
}
